import React from "react";
import { SvgIcon } from "@material-ui/core";

const EccoColor = props => (
  <SvgIcon viewBox="0 0 500 230" width="500" height="230" {...props}>
      <style type="text/css" id="style2">
        {".prefix__st10{fill-rule:evenodd;clip-rule:evenodd;fill:#0057b8}"}
      </style>
      <g
        id="prefix__g62"
        transform="matrix(.83354 0 0 .83354 38.355 -99.814)"
        strokeWidth={2.501}
      >
        <g id="prefix__g56">
          <path
            className="prefix__st10"
            id="prefix__polygon4"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
            d="M48.16 315.7h13.55l-.58 2.92H47.54l-1.9 8.98h14.72l-.66 2.92H41.5l5.52-25.99h18.03l-.58 2.91H49.92z"
          />
          <path
            className="prefix__st10"
            d="M67.82 311.7h2.9l-.7 2.8.07.08c1.61-1.97 3.99-3.31 6.59-3.31 2.38 0 4.21.94 4.76 3.37 1.47-2 3.96-3.37 6.48-3.37 2.68 0 5.28 1.15 5.28 4.21 0 1.09-.3 2.69-.55 3.75l-2.38 11.29h-3.12l2.64-11.94c.15-.58.3-1.49.3-2.04 0-1.45-1.24-2.54-2.9-2.54-1.76 0-3.7 1.24-4.77 2.58-1.01 1.09-1.43 2.62-1.76 4.22l-2.08 9.72h-3.11l2.27-10.74c.33-1.45.59-2.87.59-3.32 0-1.55-.95-2.47-2.64-2.47-1.72 0-3.54 1.17-4.65 2.4-1.31 1.27-1.61 2.4-2.02 4.26l-2.12 9.86h-3.1z"
            id="prefix__path6"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M99.14 322.03c-.08.55-.12 1.09-.12 1.63 0 2.92 2.38 4.56 4.91 4.56 2.71 0 4.58-1.28 5.46-3.61h3.12c-.99 4.15-4.44 6.33-8.57 6.33-6.27 0-8.03-4.29-8.03-7.56 0-7.2 4.54-12.11 9.75-12.11 5.56 0 8.02 3.02 8.02 8.32 0 .99-.19 1.93-.3 2.44zm11.42-2.72c.22-2.66-.99-5.31-4.43-5.31-3.66 0-5.63 2.4-6.55 5.31z"
            id="prefix__path8"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M119.35 311.7h2.93l-.92 4.03h.08c1.46-2.58 3.69-4.47 6.88-4.47.37 0 .74-.07 1.1 0l-.74 3.31c-.29-.05-.62-.05-.91-.05-.77 0-1.14 0-1.86.19-1.72.44-3.04 1.56-4.04 3.05-.84 1.2-1.28 2.99-1.58 4.41l-1.79 8.34h-3.12z"
            id="prefix__path10"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M144.95 327.78c-.44 1.94-.92 3.83-1.46 5.13-1.61 3.75-4.58 5.24-8.61 5.24-3.85 0-7.44-1.63-7.55-5.82h3.11c.18 2.51 2.38 3.1 4.76 3.1 4.84 0 5.79-3.81 6.78-7.57l-.08-.07c-1.35 2.01-3.51 2.88-5.89 2.88-4.69 0-7.11-3.32-7.11-7.79 0-5.57 3.7-11.6 9.85-11.6 2.75 0 5.45 1.45 6.01 3.82v.08h.07l.58-3.46h2.93zm-8.28.16c4.68 0 6.89-5.25 6.89-9.03 0-2.94-1.57-4.91-4.83-4.91-4.36 0-6.7 5.43-6.7 8.87 0 2.69 1.53 5.07 4.64 5.07z"
            id="prefix__path12"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M153.12 322.03c-.08.55-.11 1.09-.11 1.63 0 2.92 2.38 4.56 4.91 4.56 2.71 0 4.58-1.28 5.45-3.61h3.12c-1 4.15-4.44 6.33-8.57 6.33-6.27 0-8.03-4.29-8.03-7.56 0-7.2 4.54-12.11 9.75-12.11 5.56 0 8.02 3.02 8.02 8.32 0 .99-.19 1.93-.29 2.44zm11.43-2.72c.21-2.66-.99-5.31-4.43-5.31-3.67 0-5.64 2.4-6.55 5.31z"
            id="prefix__path14"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M173.37 311.7h3.01l-.59 2.83h.07c1.57-2.11 4.14-3.26 6.74-3.26 3.55 0 5.26 1.52 5.26 4.83 0 .8-.21 2.22-.54 3.67l-2.31 10.74h-3.11l2.42-10.99c.15-.7.44-2.26.44-2.91 0-1.78-1.46-2.62-3.3-2.62-1.72 0-3.52.94-4.69 2.18-1.1.94-1.68 2.44-2.08 3.93l-2.2 10.41h-3.11z"
            id="prefix__path16"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M205.52 317.66c0-2.3-1.57-3.67-3.99-3.67-4.8 0-7.36 4.72-7.36 8.84 0 2.91 1.21 5.39 4.69 5.39 2.67 0 4.65-1.56 5.53-3.85h3.12c-1.1 4.18-4.29 6.58-8.65 6.58-5.16 0-7.81-3.05-7.81-8.11 0-5.96 3.7-11.56 10.48-11.56 4.28 0 6.96 2.04 7.11 6.4h-3.12z"
            id="prefix__path18"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M214.09 311.7h3.12l-3.96 18.81h-3.11zm3.85-3.39h-3.15l.81-3.78h3.15z"
            id="prefix__path20"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M220.75 317.37c.62-4.18 4.18-6.11 8.21-6.11 3.66 0 6.92.97 6.92 4.8 0 1.06-.37 2.4-.59 3.42l-1.21 5.12c-.15.76-.5 1.82-.5 2.7 0 .88.41 1.17.91 1.17.3 0 .7-.15.99-.26l-.48 2.3c-.47.25-1.35.42-1.9.42-1.72 0-2.64-1.01-2.45-2.66l-.08-.07c-1.32 1.74-3.14 2.72-6.33 2.72-3.15 0-5.79-1.45-5.79-5.31 0-5.46 5.38-5.83 9.56-6.19 3.3-.29 4.76-.47 4.76-2.99 0-2.03-2.16-2.47-3.8-2.47-2.38 0-4.72.94-5.09 3.38h-3.13zm4.22 10.85c2.42 0 4.21-.81 5.3-2.48 1.03-1.42 1.22-3.09 1.66-4.83h-.08c-1.35.8-3.81.98-6.09 1.27-2.23.33-4.2 1.02-4.2 3.41.01 1.75 1.65 2.63 3.41 2.63z"
            id="prefix__path22"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M254.71 333.71c-1.54 2.44-2.93 4.44-6.12 4.44-.73 0-1.57-.18-2.16-.47l.55-2.51c.48.29 1.24.51 1.79.51 1.4 0 2.21-.84 2.93-2.04l1.9-3.12-3.34-18.81h3.34l2.2 14.95h.08l7.95-14.95h3.41z"
            id="prefix__path24"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M282.98 304.53h10.28c5.03 0 7.77 2.43 7.77 7.17 0 3.23-2.31 8.18-10 8.18h-7.76L281 330.52h-3.48zm.92 12.45h7.88c3.73 0 5.79-2.19 5.79-5.28 0-3.2-1.98-4.27-4.29-4.27h-7.36z"
            id="prefix__path26"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M305.14 311.7h2.92l-.91 4.03h.08c1.46-2.58 3.69-4.47 6.89-4.47.36 0 .73-.07 1.09 0l-.73 3.31c-.29-.05-.62-.05-.91-.05-.77 0-1.14 0-1.87.19-1.72.44-3.04 1.56-4.02 3.05-.85 1.2-1.28 2.99-1.58 4.41l-1.8 8.34h-3.11z"
            id="prefix__path28"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M317.51 322.03c-.06.55-.1 1.09-.1 1.63 0 2.92 2.37 4.56 4.9 4.56 2.72 0 4.59-1.28 5.46-3.61h3.12c-.98 4.15-4.42 6.33-8.58 6.33-6.25 0-8.01-4.29-8.01-7.56 0-7.2 4.54-12.11 9.74-12.11 5.56 0 8.01 3.02 8.01 8.32 0 .99-.17 1.93-.29 2.44zm11.43-2.72c.22-2.66-.99-5.31-4.42-5.31-3.67 0-5.64 2.4-6.56 5.31z"
            id="prefix__path30"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            id="prefix__polygon32"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
            d="M340.4 327.34h.07l8.21-15.64h3.37l-10.51 18.82h-3.34l-2.7-18.82h3.29z"
          />
          <path
            className="prefix__st10"
            d="M355.53 322.03c-.07.55-.11 1.09-.11 1.63 0 2.92 2.38 4.56 4.92 4.56 2.71 0 4.57-1.28 5.45-3.61h3.1c-.98 4.15-4.41 6.33-8.55 6.33-6.27 0-8.02-4.29-8.02-7.56 0-7.2 4.53-12.11 9.74-12.11 5.56 0 8.02 3.02 8.02 8.32 0 .99-.18 1.93-.29 2.44zm11.42-2.72c.21-2.66-.99-5.31-4.43-5.31-3.67 0-5.64 2.4-6.56 5.31z"
            id="prefix__path34"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M375.78 311.7h3.01l-.59 2.83h.08c1.58-2.11 4.13-3.26 6.75-3.26 3.54 0 5.27 1.52 5.27 4.83 0 .8-.22 2.22-.55 3.67l-2.31 10.74h-3.1l2.42-10.99c.15-.7.44-2.26.44-2.91 0-1.78-1.46-2.62-3.29-2.62-1.73 0-3.52.94-4.69 2.18-1.1.94-1.69 2.44-2.09 3.93l-2.19 10.41h-3.12z"
            id="prefix__path36"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M407.93 317.66c0-2.3-1.57-3.67-3.99-3.67-4.8 0-7.35 4.72-7.35 8.84 0 2.91 1.2 5.39 4.68 5.39 2.68 0 4.65-1.56 5.53-3.85h3.12c-1.1 4.18-4.29 6.58-8.65 6.58-5.16 0-7.8-3.05-7.8-8.11 0-5.96 3.7-11.56 10.48-11.56 4.29 0 6.95 2.04 7.11 6.4h-3.13z"
            id="prefix__path38"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M416.51 311.7h3.11l-3.95 18.81h-3.11zm3.84-3.39h-3.15l.81-3.78h3.14z"
            id="prefix__path40"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M432.44 311.27c5.06 0 7.87 2.75 7.87 7.77 0 6.15-3.84 11.9-10.47 11.9-4.98 0-7.98-3.31-7.98-7.86-.01-6.15 3.94-11.81 10.58-11.81zm-2.27 16.95c4.54 0 7.03-5.2 7.03-8.91 0-2.95-1.58-5.31-4.98-5.31-4.76 0-7.25 5.16-7.25 9.06-.01 3.09 1.79 5.16 5.2 5.16zm5.01-24.31h4.13l-4.98 5.2h-2.56z"
            id="prefix__path42"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M446.42 311.7h3.01l-.59 2.83h.08c1.58-2.11 4.14-3.26 6.74-3.26 3.55 0 5.27 1.52 5.27 4.83 0 .8-.22 2.22-.55 3.67l-2.31 10.74h-3.11l2.41-10.99c.14-.7.44-2.26.44-2.91 0-1.78-1.46-2.62-3.3-2.62-1.72 0-3.52.94-4.68 2.18-1.11.94-1.69 2.44-2.09 3.93l-2.2 10.41h-3.11z"
            id="prefix__path44"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            id="prefix__polygon46"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
            d="M159.77 210.46h44.57l-4.65 21.55h-44.55l-2.44 11.27h50.53l-5 23.18h-79.6L138.11 176h78.13l-4.98 23.18h-49.05z"
          />
          <path
            className="prefix__st10"
            d="M276.01 209.69c.18-3.3-.31-13.29-12.33-13.29-13.62 0-20.71 12.67-23.34 24.82-2.62 12.17-.98 24.83 12.65 24.83 9.78 0 15.04-6.58 18.57-15.06h28.58c-3.94 18.24-23.57 37.62-51.22 37.62-30.55 0-43.41-20.65-37.66-47.39 6.12-28.5 28.97-47.37 58.06-47.37 25.9.12 37.34 13.18 35 35.84z"
            id="prefix__path48"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M372.59 209.69c.18-3.3-.31-13.29-12.35-13.29-13.61 0-20.7 12.67-23.33 24.82-2.62 12.17-.97 24.83 12.65 24.83 9.79 0 15.03-6.58 18.57-15.06h28.56c-3.92 18.24-23.56 37.62-51.2 37.62-30.56 0-43.42-20.65-37.67-47.39 6.13-28.5 28.97-47.37 58.08-47.37 25.87.12 37.36 13.18 34.99 35.84z"
            id="prefix__path50"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M433.5 221.22c4.33-20.13 16.71-24.82 24.1-24.82 7.41 0 17.78 4.69 13.44 24.82-4.33 20.15-16.72 24.83-24.12 24.83-7.39.01-17.76-4.68-13.42-24.83zm-29.11 0c-5.94 27.63 8.99 47.39 37.68 47.39 28.69 0 52.12-19.75 58.06-47.39 5.95-27.61-8.96-47.37-37.66-47.37-28.71 0-52.13 19.76-58.08 47.37z"
            id="prefix__path52"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
          <path
            className="prefix__st10"
            d="M108 211.09l-14.05-24.61-17.73 10.35v-20.7H48.13v20.7l-17.72-10.35-14.06 24.61 17.74 10.34-17.74 10.35 14.05 24.6 17.72-10.34v20.7h28.09v-20.7l17.73 10.34 14.05-24.6-17.72-10.35zm-45.05-29.62c4.08 0 4.85 4.58 4.85 4.58l-2.91 35.25s-.28.94-.45 1.56c-.36 1.35-4.98 7.65-4.98 8.29l-1.3-34.24c0-1.36 1.3-2.46 1.3-2.46 6.59-2.84 4.6-8.69 4.6-8.69-3.3-1.36-6.24 1.05-6.24 1.05s1.06-5.34 5.13-5.34zm-6.34 9.46c.39-2.07 1.88-3.36 1.88-3.36 2.58-1.75 4.49-.87 4.49-.87 1.03 4.98-4.3 6.92-4.3 6.92-3.62 4.52-1.16 10.53-1.16 10.53l.19 8.29c-10.02-10.74-1.1-21.51-1.1-21.51zm4.98 69.22h-1.04l-.77-18.45s.29-2.24 3.94-5.86zm7.89-35.88c-.45 5.04-7.18 10.61-9.37 13.71-2.21 3.1-1.06 7.66-1.06 7.66l.13 5.63c-4.58-6.79-2.37-12.51-2.37-12.51.4-2.08 3.43-6.66 6.53-10.86 3.1-4.22 2.81-5.77 2.81-5.77l.52-8.08c.9 1.23 3.26 5.17 2.81 10.22z"
            id="prefix__path54"
            clipRule="evenodd"
            fill="#0057b8"
            fillRule="evenodd"
            strokeWidth={2.501}
          />
        </g>
        <g id="prefix__g60">
          <path
            id="prefix__rect58"
            clipRule="evenodd"
            fill="#ff8200"
            fillRule="evenodd"
            strokeWidth={2.501}
            d="M10.4 283.36h491.2v5.57H10.4z"
          />
        </g>
      </g>
  </SvgIcon>
);

export default EccoColor;
